window.acceleratedDataQueue = window.acceleratedDataQueue || [];
window.acceleratedDataQueue.push({
            'ACC_SCS_Cartdrawer_32': {
                // Was a Swiper carousel (external swiper-bundle JS+CSS injected from
                // jsdelivr just for this one horizontal "You may also like" scroller).
                // Replaced with a plain scroll-snap flex row — see the
                // .ACC_SCS_Cartdrawer_32_reviews_section / _review_slide rules in
                // theme-css.liquid. No JS init needed, no external library.

                var: {
                    related: new Set(),
                    gifts: new Set()

                },
                refreshCart: async function() {
                        let self = this;

                        function toMoney(cents) {
                            if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
                                return window.Shopify.formatMoney(cents);
                            }
                            return new Intl.NumberFormat("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2,
                            }).format((cents || 0) / 100);
                        }


                        let cart = await fetch('/cart.js').then(response => response.json());
                        const hasSeatCover = cart && cart.items && cart.items.some(item => item.handle.includes('luxury-seat-covers'));
                        const cartHasTruckVehicle = Boolean(window.is_real_truck) || (cart && cart.items && cart.items.some((item) => {
                            const variantText = String(item.variant_title || '').toLowerCase();
                            if (variantText.includes('truck')) return true;
                            const properties = item && item.properties ? Object.values(item.properties) : [];
                            return properties.some((value) => String(value || '').toLowerCase().includes('truck'));
                        }));
                        if (!cart || !cart.items || cart.items.length === 0) {

                            self.runAt(".ACC_SCS_Cartdrawer_32_reviews_wrapper", function() {
                                document.querySelector(".ACC_SCS_Cartdrawer_32_reviews_wrapper")?.remove();
                                document.querySelector(".ACC_SCS_Cartdrawer_32_wrapper_gift")?.remove();
                            });
                            self.var.gifts.clear();
                            self.var.related.clear();
                            return;
                        }

                        let cartitems = document.querySelectorAll(".rebuy-cart__flyout-content.has-items ul li");

                        const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

                        cartitems.forEach((list) => {
                            let free = list.querySelector(".rebuy-cart__flyout-item-discount-message");
                            if (free) {
                                let content = (free.textContent || free.innerText).trim();

                                if (uuidPattern.test(content)) {
                                    free.style.display = 'none';
                                }

                                const priceSpan = list.querySelector('.rebuy-cart__flyout-item-price .rebuy-money span[tabindex="0"]');
                                const isFreeByPrice = priceSpan && priceSpan.textContent.trim().replace(/\D/g, '') == 0;

                                if (content && content.toLowerCase().includes("free item") && isFreeByPrice) {
                                    list.classList.add("ACC_SCS_Cartdrawer_32_gift_item_hide");
                                }
                            }
                        });



                          self.var.gifts.clear();
                        cart.items.forEach((item) => {
                            
                            if (item.line_price === 0) {
                                
                                    self.var.gifts.add(item);
                                
                            }
                        });

                        let gifts = Array.from(self.var.gifts);
                         const quantitycheck = gifts.reduce((acc, item) => {
                         acc[item.title] = (acc[item.title] || 0) + item.quantity;
                            return acc;
                           }, {});

                        gifts = [...new Map(gifts.map(item => [item.title, item])).values()];

                        if (gifts.length > 0) {
                            self.runAt(".rebuy-cart__flyout-recommendations", function([target]) {

                                        let html = `<div class="${self.__testName}_wrapper_gift">
                            <div class="${self.__testName}_wrapper_giftHeading">FREE PREMIUM ADD-ONS 🎁</div>
                            <div class="${self.__testName}_wrapper_giftPrpoducts">
                            ${
                            gifts.map(gift=>{
                            return `
                            <div class="${self.__testName}_gift_product_card">
                            <div class="${self.__testName}_gift_product_cardImg">
                            <span class="${self.__testName}_gift_quantity">${quantitycheck[gift.title]}</span>
                            <img src="${gift.featured_image.url}" alt="${gift.title}" />
                            </div>
                            <div class="${self.__testName}_gift_product_content">
                            <div class="${self.__testName}_gift_product_title">
                            ${gift.product_title} ${gift.variant_title ? `| <div class="${self.__testName}_gift_product_variant"> ${gift.variant_title}</div>`: ''}
                            </div>
                            <div class="${self.__testName}_gift_product_priceContainer">
                            <div class="${self.__testName}_gift_product_free">${toMoney(gift.line_price)}</div>
                            <div class="${self.__testName}_gift_product_original">${toMoney(gift.original_price)}</div>
                            </div>

                            </div>
                            </div>
                            `;
                            }).join('')
                            }
                            </div>

                            </div>`;

                    let check = document.querySelector(".ACC_SCS_Cartdrawer_32_wrapper_gift");
                    if (check) {
                        check.outerHTML = html;
                    } else {

                        target.insertAdjacentHTML('beforebegin', html);
                    }

                })

            }
            self.runAt(".rebuy-product-block", function () {

                let productBlocks = document.querySelectorAll(".rebuy-cart__flyout-recommendations .rebuy-product-block a");
                productBlocks.forEach((block) => {
                    let url = new URL(block.href);
                    let productHandle = url.pathname.split("/products/")[1];
                    if (!self.var.related.has(productHandle)) {
                        self.var.related.add(productHandle);
                    }

                })
            })

            let handles = Array.from(self.var.related);
            let products = [];
            for (let handle of handles) {
                let product = await fetch(`/products/${handle}.js`).then(response => response.json());
                if (!product || !product.available) {
                    continue;
                }
                let isInCart = cart.items.some(item => item.handle === handle);
                if (!isInCart) {
                    products.push(product);
                }
            }

            if (products.length == 0) {
                document.querySelector(".ACC_SCS_Cartdrawer_32_reviews_wrapper")?.remove();
            }

            if (products.length > 0) {
                let slider = `
<div class="${self.__testName}_reviews_wrapper">
<div class="${self.__testName}_reviews_heading">You may also like</div>
<div class="${self.__testName}_reviews_section">
`;

                products.forEach((product) => {
                    const isPetSuiteDiscount = hasSeatCover && product.handle === 'petsuite-hard-bottom-dog-seat-protector-no-fur';
                    const preferredVariantIndex = cartHasTruckVehicle
                        ? product.variants.findIndex((variant) => String(variant.title || '').toLowerCase().includes('truck'))
                        : -1;
                    const selectedVariant = product.variants[preferredVariantIndex >= 0 ? preferredVariantIndex : 0] || product.variants[0];
                    const cardCompareAt = isPetSuiteDiscount ? selectedVariant.price : selectedVariant.compare_at_price;
                    const cardPrice = isPetSuiteDiscount ? selectedVariant.price - 7000 : selectedVariant.price;
                    const showCardCompareAt = isPetSuiteDiscount || (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price);
                    slider += `
<div class="${self.__testName}_review_slide">
<div class="${self.__testName}_review_product_card" data-product-handle="${product.handle}">
<a href="/products/${product.handle}" >
<img src="${product.images[0]}" alt="${product.title}" />
</a>
<div class="${self.__testName}_review_product_content">
<div class="${self.__testName}_review_product_title">
<a href="/products/${product.handle}" >
${product.title.split(' ').slice(0,7).join(' ')}${product.title.split(' ').length > 7 ? '...' : ''}
</a>
</div>

${product.variants.length > 1  ? `
<div class="${self.__testName}_review_product_variant_selector">

${product.variants.map((variant, index) => `

<label 
class="${self.__testName}_review_product_variant_option"
data-value="${variant.id}"
>
<input
type="radio"
name="variant-${product.id}"
data-compare-at-price="${variant.compare_at_price}"
data-price="${variant.price}"
data-image="${variant.featured_image ? variant.featured_image.src : product.images[0]}"
value="${variant.id}"
${index === (preferredVariantIndex >= 0 ? preferredVariantIndex : 0) ? 'checked' : ''}
/>

<span class="${self.__testName}_review_product_variant_radio_new">


<svg class="${self.__testName}_activesvg" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="0.5" width="16" height="16" rx="8" fill="white"/>
<rect x="0.5" y="0.5" width="16" height="16" rx="8" stroke="#C0C0C0"/>
<rect x="3" y="3" width="11" height="11" rx="5.5" fill="#2D671C"/>
</svg>


<svg class="${self.__testName}_inactivesvg" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="0.5" width="16" height="16" rx="8" fill="white"/>
<rect x="0.5" y="0.5" width="16" height="16" rx="8" stroke="#C0C0C0"/>
</svg>



</span>

<span class="${self.__testName}_review_product_variant_name">
${variant.title}
</span>
</label>

`).join('')}

</div>
` : `<input
type="radio"
name="variant-${product.id}"
value="${product.variants[0].id}"
checked
/>`}


<div class="${self.__testName}_review_product_form">
<div class="${self.__testName}_review_product_price_section">
<span style="display:${showCardCompareAt ? 'inline-block' : 'none'}" class="${self.__testName}_review_product_price">${toMoney(cardCompareAt)}</span>
<span class="${self.__testName}_review_product_price_discounted">${toMoney(cardPrice)}</span>
</div>
<div class="${self.__testName}_atc">Add</div>
</div>
</div>


</div>
</div>
`;
                });

                slider += `
</div>
</div>
`;


                self.runAt(".rebuy-cart__flyout-recommendations", function () {
                    let container = document.querySelector(".rebuy-cart__flyout-recommendations");

                    if (container) {
                        container.innerHTML = slider;

                        document.querySelectorAll(".ACC_SCS_Cartdrawer_32_review_product_variant_option input").forEach((radio) => {
                            radio.addEventListener("change", function () {
                                let productCard = radio.closest(
                                    `.${self.__testName}_review_product_card`
                                );
                                if (!productCard) return;

                                let price = radio.getAttribute("data-price");
                                let compareAtPrice = radio.getAttribute("data-compare-at-price");
                                let imageSrc = radio.getAttribute("data-image");
                                const variantIsPetSuiteDiscount = hasSeatCover && productCard.getAttribute('data-product-handle') === 'petsuite-hard-bottom-dog-seat-protector-no-fur';

                                let priceElement = productCard.querySelector(
                                    `.${self.__testName}_review_product_price_discounted`
                                );
                                let compareAtPriceElement = productCard.querySelector(
                                    `.${self.__testName}_review_product_price`
                                );
                                let imageElement = productCard.querySelector("img");

                                if (priceElement) {
                                    priceElement.textContent = toMoney(variantIsPetSuiteDiscount ? +price - 7000 : price);
                                }
                                if (!!compareAtPriceElement) {
                                    if (variantIsPetSuiteDiscount) {
                                        compareAtPriceElement.textContent = toMoney(price);
                                        compareAtPriceElement.style.display = "inline-block";
                                    } else if (!!compareAtPrice && +compareAtPrice > price) {
                                        compareAtPriceElement.textContent = toMoney(compareAtPrice);
                                        compareAtPriceElement.style.display = "inline-block";
                                    } else {
                                        compareAtPriceElement.style.display = "none";
                                    }
                                }
                                if (imageElement) {
                                    imageElement.src = imageSrc;
                                }
                            });
                        });

                        document
                            .querySelectorAll(".ACC_SCS_Cartdrawer_32_atc")
                            .forEach((button) => {
                                button.addEventListener("click", async function () {
                                    let productCard = button.closest(
                                        `.${self.__testName}_review_product_card`
                                    );
                                    if (!productCard) return;

                                    let variantOption = productCard.querySelector(
                                        `input[type="radio"]:checked`
                                    );
                                    if (!variantOption) return;

                                    let variantId = variantOption.value;
                                    let productHandle = productCard.getAttribute('data-product-handle');

                                    try {
                                        const body = {
                                            id: variantId,
                                            quantity: 1,
                                        };
                                        if (productHandle === 'petsuite-hard-bottom-dog-seat-protector-no-fur') {
                                            body.properties = { _widget_id: 295798 };
                                        }
                                        const response = await fetch("/cart/add.js", {
                                            method: "POST",
                                            headers: {
                                                "Content-Type": "application/json",
                                                Accept: "application/json",
                                            },
                                            body: JSON.stringify(body),
                                        });

                                        const data = await response.json();

                                    } catch (error) {
                                        console.error("Error adding product to cart:", error);
                                    }
                                });
                            });
                    }
                });


            }
        },
        init() {
            let self = this;
            self.runAt("#rebuy-cart", function () {
                const body = document.body;

                self.refreshCart();

                new PerformanceObserver(function (e) {
                    !e.getEntriesByType("resource").some(({
                        name
                    }) => /\/cart\/(change|update|add|clear)/i.test(name)) || self.refreshCart()
                }).observe({
                    entryTypes: ["resource"]
                });

                const observer = new MutationObserver((mutationList) => {
                    for (const mutation of mutationList) {
                        if (mutation.type === "attributes" && mutation.attributeName === "class") {
                            if (body.classList.contains("rebuy-cart-visible")) {
                                self.refreshCart();
                            }
                        }
                    }
                });

                observer.observe(body, {
                    attributes: true,
                    attributeFilter: ["class"]
                });
            })


        }
    }
});